import { t } from '@lingui/macro';
import { useAuthContext } from 'noddi-provider';
import { FixedBottomBarContainer, NoddiBasicCard } from 'noddi-ui-web';

import { URLKeys, noddiAsync } from 'noddi-async';
import HelpScoutChat from '../../../components/BookingFlow/HelpScoutChat';
import { CustomerSMSLogin } from '../../../components/CustomerSMSLogin';
import { ErrorPageWithTranslations } from '../../../components/ErrorPageWithTrans';
import { NoddiLoadingScreenWithTrans } from '../../../components/NoddiLoadingScreenWithTrans';
import { CommonBookingInfoCard } from '../../../components/Summary/CommonBookingInfoCard';
import { ShoppingCartSummary } from '../../../components/Summary/ShoppingCartSummary';
import { BrandBanner } from '../../BookingFlow/components/BrandAnnouncement';
import CommentBox from '../../BookingFlow/Steps/Summary/CommentBox';
import { RecallContentWrapper } from '../ContentWrapper';
import { useRecallActions, useRecallComment, useRecallMetaData } from '../recallStore';
import { ConfirmRecall } from './ConfirmRecall';

export const RecallSummary = () => {
  const { isLoggedIn } = useAuthContext();

  const { setComment } = useRecallActions();
  const comment = useRecallComment();
  const { slug } = useRecallMetaData();

  const {
    data: booking,
    isPending: isBookingPending,
    error: bookingError
  } = noddiAsync.useGet({
    type: URLKeys.getRecallBooking,
    input: { slug: slug! }
  });

  if (isBookingPending) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (bookingError) {
    return <ErrorPageWithTranslations apiError={bookingError} />;
  }

  const { deliveryWindowStartsAt, deliveryWindowEndsAt, address } = booking;

  const selectedBookingTimeWindow = {
    startsAt: deliveryWindowStartsAt,
    endsAt: deliveryWindowEndsAt,
    timeZone: address.timeZone
  };

  return (
    <RecallContentWrapper title={t`Does this look correct?`}>
      <div className='flex flex-col gap-4'>
        {isLoggedIn ? (
          <CommentBox comment={comment} handleChange={setComment} />
        ) : (
          <NoddiBasicCard>
            <CustomerSMSLogin />
          </NoddiBasicCard>
        )}

        <CommonBookingInfoCard address={address} timeWindow={selectedBookingTimeWindow} />

        <NoddiBasicCard>
          <BrandBanner brand={booking.brand} className='mb-3' />
          <ShoppingCartSummary shoppingCart={booking} />
        </NoddiBasicCard>
      </div>
      <FixedBottomBarContainer>
        <HelpScoutChat />
        <ConfirmRecall />
      </FixedBottomBarContainer>
    </RecallContentWrapper>
  );
};
